import * as Data$dFunctor$dCompose from "../Data.Functor.Compose/index.js";
import * as Restaumatic$dForm$dResult from "../Restaumatic.Form.Result/index.js";
import * as Specular$dFRP$dBase from "../Specular.FRP.Base/index.js";
import * as Specular$dInternal$dIncremental$dNode from "../Specular.Internal.Incremental.Node/index.js";
import * as Unsafe$dCoerce from "../Unsafe.Coerce/index.js";
const DynamicResult = x => x;
const functorDynamicResult = {map: f => v => Specular$dFRP$dBase.functorDynamic.map(Restaumatic$dForm$dResult.functorResult.map(f))(v)};
const hasFieldDynamicResultDyna = dictHasField => ({getField: label => functorDynamicResult.map(dictHasField.getField(label))});
const applyDynamicResult = {
  apply: v => v1 => Specular$dFRP$dBase.applyDynamic.apply(Specular$dFRP$dBase.functorDynamic.map(Restaumatic$dForm$dResult.applyResult.apply)(v))(v1),
  Functor0: () => ({map: f => v => Specular$dFRP$dBase.functorDynamic.map(Restaumatic$dForm$dResult.functorResult.map(f))(v)})
};
const semigroupDynamicResult = dictSemigroup => (
  {
    append: (() => {
      const $0 = dictSemigroup.append;
      return a => b => Specular$dFRP$dBase.applyDynamic.apply(Specular$dFRP$dBase.functorDynamic.map(Restaumatic$dForm$dResult.applyResult.apply)(Specular$dFRP$dBase.functorDynamic.map(Restaumatic$dForm$dResult.functorResult.map($0))(a)))(b);
    })()
  }
);
const applicativeDynamicResult = /* #__PURE__ */ Data$dFunctor$dCompose.applicativeCompose(Specular$dFRP$dBase.applicativeDynamic)(Restaumatic$dForm$dResult.applicativeResult);
const monoidDynamicResult = dictMonoid => ({mempty: applicativeDynamicResult.pure(dictMonoid.mempty), Semigroup0: () => semigroupDynamicResult(dictMonoid.Semigroup0())});
const additiveDynamicResult = dictAdditive => (
  {
    zero: applicativeDynamicResult.pure(dictAdditive.zero),
    add: (() => {
      const $0 = dictAdditive.add;
      return a => b => Specular$dFRP$dBase.applyDynamic.apply(Specular$dFRP$dBase.functorDynamic.map(Restaumatic$dForm$dResult.applyResult.apply)(Specular$dFRP$dBase.functorDynamic.map(Restaumatic$dForm$dResult.functorResult.map($0))(a)))(b);
    })(),
    sub: (() => {
      const $0 = dictAdditive.sub;
      return a => b => Specular$dFRP$dBase.applyDynamic.apply(Specular$dFRP$dBase.functorDynamic.map(Restaumatic$dForm$dResult.applyResult.apply)(Specular$dFRP$dBase.functorDynamic.map(Restaumatic$dForm$dResult.functorResult.map($0))(a)))(b);
    })()
  }
);
const wrap = x => x;
const unwrap = v => v;
const unsafeStrenghten = Unsafe$dCoerce.unsafeCoerce;
const toTotal = x => Specular$dFRP$dBase.functorDynamic.map(Restaumatic$dForm$dResult.toTotal)(x);
const toStrict = x => Specular$dFRP$dBase.functorDynamic.map(Restaumatic$dForm$dResult.toStrict)(x);
const toLax = x => Specular$dFRP$dBase.functorDynamic.map(Restaumatic$dForm$dResult.toLax)(x);
const relax = () => Unsafe$dCoerce.unsafeCoerce;
const over = f => x => Specular$dFRP$dBase.functorDynamic.map(f)(x);
const liftFinal = x => Specular$dFRP$dBase.functorDynamic.map(Restaumatic$dForm$dResult.liftV)(x);
const liftDynamic = x => Specular$dFRP$dBase.functorDynamic.map(Restaumatic$dForm$dResult.applicativeResult.pure)(x);
const heytingAlgebraFinal = dictHeytingAlgebra => (
  {
    ff: applicativeDynamicResult.pure(dictHeytingAlgebra.ff),
    tt: applicativeDynamicResult.pure(dictHeytingAlgebra.tt),
    implies: (() => {
      const $0 = dictHeytingAlgebra.implies;
      return a => b => Specular$dFRP$dBase.applyDynamic.apply(Specular$dFRP$dBase.functorDynamic.map(Restaumatic$dForm$dResult.applyResult.apply)(Specular$dFRP$dBase.functorDynamic.map(Restaumatic$dForm$dResult.functorResult.map($0))(a)))(b);
    })(),
    conj: (() => {
      const $0 = dictHeytingAlgebra.conj;
      return a => b => Specular$dFRP$dBase.applyDynamic.apply(Specular$dFRP$dBase.functorDynamic.map(Restaumatic$dForm$dResult.applyResult.apply)(Specular$dFRP$dBase.functorDynamic.map(Restaumatic$dForm$dResult.functorResult.map($0))(a)))(b);
    })(),
    disj: (() => {
      const $0 = dictHeytingAlgebra.disj;
      return a => b => Specular$dFRP$dBase.applyDynamic.apply(Specular$dFRP$dBase.functorDynamic.map(Restaumatic$dForm$dResult.applyResult.apply)(Specular$dFRP$dBase.functorDynamic.map(Restaumatic$dForm$dResult.functorResult.map($0))(a)))(b);
    })(),
    not: functorDynamicResult.map(dictHeytingAlgebra.not)
  }
);
const annotated = name => x => {
  Specular$dInternal$dIncremental$dNode.annotate(x, name);
  return x;
};
const andThen = v => k => Specular$dFRP$dBase.bindDynamic.bind(v)(x => Restaumatic$dForm$dResult.andThenA(Specular$dFRP$dBase.applicativeDynamic)(x)(x$1 => k(x$1)));
export {
  DynamicResult,
  additiveDynamicResult,
  andThen,
  annotated,
  applicativeDynamicResult,
  applyDynamicResult,
  functorDynamicResult,
  hasFieldDynamicResultDyna,
  heytingAlgebraFinal,
  liftDynamic,
  liftFinal,
  monoidDynamicResult,
  over,
  relax,
  semigroupDynamicResult,
  toLax,
  toStrict,
  toTotal,
  unsafeStrenghten,
  unwrap,
  wrap
};
